import CVForm from "./cvform";

const CreateCV = () => {
  return <CVForm />;
};

export default CreateCV;